import { useState } from 'react';
import { useOnMount } from 'tradera/hooks/use-on-mount';

export const useIsPostHydrationClientRender = () => {
    const [isPostHydrationClientRender, setIsPostHydrationClientRender] =
        useState(false);
    useOnMount(() => setIsPostHydrationClientRender(true));
    return isPostHydrationClientRender;
};
